import React from 'react';
import { Platform, View } from 'react-native';
import { Typography } from '../ui';
import { fontWeights } from '../../styles/typographyTokens';

/**
 * SelfHostedBadge (CORE-393) — a small "SH" pill shown when a room/live is
 * running on the self-hosted LiveKit backend (vs Agora). Purely a dev/QA aid
 * so testers can tell at a glance which RTC backend a session is using.
 *
 * Web-only (Platform guard) — it's a debugging affordance, not a product UI.
 * Render it unconditionally and pass `visible`; it returns null when the
 * session is on Agora or on native.
 */
export const SelfHostedBadge: React.FC<{ visible?: boolean; style?: any }> = ({ visible = true, style }) => {
  if (!visible || Platform.OS !== 'web') return null;
  return (
    <View
      accessibilityLabel="Self-hosted (LiveKit)"
      // @ts-expect-error web-only title tooltip
      title="Self-hosted (LiveKit)"
      style={[
        {
          paddingHorizontal: 6,
          paddingVertical: 2,
          borderRadius: 5,
          backgroundColor: 'rgba(16,185,129,0.92)',
          alignItems: 'center',
          justifyContent: 'center',
        },
        style,
      ]}
    >
      <Typography style={{ color: '#FFF', fontSize: 10, fontWeight: fontWeights.bold, letterSpacing: 0.5 } as any}>SH</Typography>
    </View>
  );
};
